export default __webpack_public_path__ + "static/media/25.f7da88e2.png";